import { render } from "./InboundBenchmark.vue?vue&type=template&id=3004d0e6&scoped=true"
import script from "./InboundBenchmark.vue?vue&type=script&lang=js"
export * from "./InboundBenchmark.vue?vue&type=script&lang=js"

import "./InboundBenchmark.vue?vue&type=style&index=0&id=3004d0e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3004d0e6"]])

export default __exports__